import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteSupplierInvoiceProjectRelation = (
    token: string,
    backend: string,
    id?: number
) => {
    return fetch(
        `${getApiUrl(backend)}supplier_invoice_project_relations/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteSupplierInvoiceProjectRelation;
